export function createFundingSettings() {
  return {
    funding_enabled: false,
    slug: "",
    promotion_code: "",
    visibility: "private",
    display_order: 0,
    goal_amount_krw: 500000,
    starts_at: "",
    ends_at: "",
    hero_image_slot: "pattern_1",
    card_image_slot: "thumbnail",
    show_funded_amount: true,
    show_progress_rate: true,
    show_backer_count: true,
    show_countdown: true,
  }
}

function toLocalDateTime(value) {
  if (!value) return ""
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ""
  const localTime = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
  return localTime.toISOString().slice(0, 16)
}

export function campaignToFundingSettings(campaign) {
  if (!campaign) return createFundingSettings()
  const settings = campaign.settings || {}

  return {
    ...createFundingSettings(),
    funding_enabled: Boolean(campaign.funding_enabled),
    slug: campaign.slug || "",
    promotion_code: campaign.promotion_code || "",
    visibility: campaign.visibility || "private",
    display_order: Number(campaign.display_order || 0),
    goal_amount_krw: Number(campaign.goal_amount_krw || 500000),
    starts_at: toLocalDateTime(campaign.starts_at),
    ends_at: toLocalDateTime(campaign.ends_at),
    hero_image_slot: settings.hero_image_slot || "pattern_1",
    card_image_slot: settings.card_image_slot || "thumbnail",
    show_funded_amount: settings.show_funded_amount !== false,
    show_progress_rate: settings.show_progress_rate !== false,
    show_backer_count: settings.show_backer_count !== false,
    show_countdown: settings.show_countdown !== false,
  }
}

export function fundingPayload(funding, conceptId) {
  const payload = {
    concept_id: Number(conceptId),
    funding_enabled: Boolean(funding.funding_enabled),
  }

  if (!funding.funding_enabled) return payload

  return {
    ...payload,
    slug: funding.slug.trim(),
    promotion_code: funding.promotion_code.trim(),
    visibility: funding.visibility,
    display_order: Number(funding.display_order || 0),
    goal_amount_krw: Number(funding.goal_amount_krw),
    starts_at: new Date(funding.starts_at).toISOString(),
    ends_at: new Date(funding.ends_at).toISOString(),
    settings: {
      hero_image_slot: funding.hero_image_slot,
      card_image_slot: funding.card_image_slot,
      show_funded_amount: Boolean(funding.show_funded_amount),
      show_progress_rate: Boolean(funding.show_progress_rate),
      show_backer_count: Boolean(funding.show_backer_count),
      show_countdown: Boolean(funding.show_countdown),
    },
  }
}

export async function loadFundingSettings(http, conceptId) {
  try {
    const response = await http.get(`/api/admin/funding/projects/by-concept/${conceptId}`)
    return {
      exists: Boolean(response.data && response.data.campaign),
      funding: campaignToFundingSettings(response.data && response.data.campaign),
    }
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return { exists: false, funding: createFundingSettings() }
    }
    throw error
  }
}

export async function saveFundingSettings(http, conceptId, funding) {
  return http.put(
    `/api/admin/funding/projects/by-concept/${conceptId}`,
    fundingPayload(funding, conceptId)
  )
}
